import {
    useState,
    useEffect
}
from "react";

import {
    functions
}
from "../../../constants/common-functions";

export default function useSpaceOrgDashboardFloor(floorId)
{
    const [dashboard, setDashboard] =
        useState(null);
		
		

		useEffect(
		    function()
		    {
		        if(!floorId)
		        {
		            return;
		        }

		        functions.getObjectFromAjax(
		            "/resolutionsoftwareplatform/spaceorgdashboardfloor?floorId=" +
		            floorId,
		            function(obj)
		            {
		                setDashboard(
		                    obj
		                );
		            },
		            null
		        );
		    },
		    [
		        floorId
		    ]
		);

    if(!dashboard)
    {
        return {
            spaceBreakdown: [],
            spaces: [],
			floorName:''
        };
    }


	const spaceBreakdown =
	   dashboard.spaceBreakdown;
	   
	const floorName = dashboard.floorName;
	   
    const spaces = dashboard.spaces;
	

    return {
       spaceBreakdown,
       spaces,
	   floorName
    };
}